import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Card, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt, faSave, faEdit, faBroomBall } from '@fortawesome/free-solid-svg-icons';
import APICom from '../utils/helpers/APICom';
import ConfirmationModal from '../components/Controls/ConfirmationModal';
import AlgoSettingsComponent from '../components/ManifestSetting/algoSettings';
import GeneralSettingsComponent from '../components/ManifestSetting/generalSettings';
import ParaTransit from '../components/RouteSettings/Paratransit';
import Cluster from '../components/RouteSettings/Cluster';
import MicroTransit from '../components/RouteSettings/Microtransit';
import { mainstore } from '../store';
import GlobalSettings from '../components/RouteSettings/GlobalSettings';

const TripFilterInterface = () => {
  const [AffiliateID, setAffiliateID] = useState(-1)
  const [sharedData, setSharedData] = useState(null);  // You can adjust the initial state as needed
  const xCancelSourceForGrid = useRef(null);
  const prevIterationsRef = useRef({});
  const [attributeTypes, setAttributeTypes] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [_algorithms, setAlgorithms] = useState([]);
  const [iterations, setIterations] = useState({});
  const [outerActiveTab, setOuterActiveTab] = useState("ParaTransit");
  const { AffiliateData } = useSelector((store) => store.combinedata);
  const { isLoggedIn, loginData } = useSelector((store) => store.login);
  const [UserAffiliateList, setUserAffiliateList] = useState(
    loginData.UserAffiliateList.split(',').map(id => Number(id))
  );
  

  const tabButtonStyle = {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#f0f0f0',
    border: '2px solid transparent',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: '#333',
    fontWeight: 'bold',
    outline: 'none',
  };
  // Inline CSS for active tab
  const activeTabStyle = {
    backgroundColor: '#87CEFA',
    color: 'white',
    borderColor: '#87CEFA',
  };

  // Inline CSS for hover state
  const hoverTabStyle = {
    backgroundColor: '#ddd',
    borderColor: '#ccc',
  };



  const transformRuleData = (rule, attributeTypes, attributes) => {
    if (!rule?.iAttributeTypeID || !rule?.iAttributeID) {
      return {
        id: rule?.iID,
        attributeType: 'None',
        attribute: 'None',
        dAcceptableCostRevThreshold: 0,
        active: rule?.bActive || false,
        only: rule?.bAttributeOnly || false,
        matchExempted: rule?.bApplyAttribute || false,
      };
    }

    const attributeType = attributeTypes?.find(type => type?.iID === rule?.iAttributeTypeID);
    const attribute = attributes?.find(attr => attr?.iID === rule?.iAttributeID);

    return {
      id: rule?.iID,
      attributeType: attributeType?.vName || 'None',
      attribute: attribute?.vTitle || 'None',
      only: rule?.bAttributeOnly || false,
      active: rule?.bActive || false,
      dAcceptableCostRevThreshold: rule?.dAcceptableCostRevThreshold || 999999,
      matchExempted: rule?.bApplyAttribute || false,
    };
  };
  const fetchAlgoSettings = async (SettingType) => {
    var status=false;
    try {
      if (AffiliateID !== '' && AffiliateID !== -1) {
        // alert('here')
        let qstr=`api/Settings/GetMVRouteGeneralSettings?affiliate_id=${AffiliateID}&iSettingType=${SettingType}&bActive=true`;
        const response = await APICom.fetchData(
          'GenericManifestDotNetCoreURL',
          qstr,
          'get',
        );
        if (response?.data?.Table?.length>0) {
          // alert('there')
          status=true;
          setAlgorithms(response?.data?.Table1)

        }
      }
      else{
      }
    } catch (error) {
      console.error('Error fetching algo settings', error);
    }
    return status;
  };
  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const id =params.get('id')
    // console.log(id)
    setAffiliateID(id)

    const fetchData = async () => {
      const payload = {
        iAffiliateID: id,
        iSettingID: sharedData
      };
      if (sharedData != null) {
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAttributeSettings", "post", {}, payload, xCancelSourceForGrid.current);

        if (response?.data) {
          console.log(response.data);
          setAttributeTypes(response?.data?.AttributeTypeData);
          setAttributes(response?.data?.AttributeData);

          const transformedIterations = {};
          response?.data?.RulesData?.forEach(rule => {
            if (!transformedIterations[rule?.iIteration]) {
              transformedIterations[rule?.iIteration] = {
                rules: [],
                routeType: rule?.vRouteFilter || 'All'
              };
            }

            const transformedRule = transformRuleData(rule, response?.data?.AttributeTypeData, response?.data?.AttributeData);
            transformedIterations[rule?.iIteration]?.rules.push(transformedRule);
          });

          setIterations(transformedIterations);
        }
      }
    };

    fetchData();
  }, [sharedData]);

  const setActiveTab = async () => {
    try {
      if (await fetchAlgoSettings(0)) {
        setOuterActiveTab('ParaTransit');
      } else if (await fetchAlgoSettings(4)) {
        setOuterActiveTab('Cluster');
      } else {
        setOuterActiveTab('MicroTransit');
      }
    } catch (error) {
      console.error("Error setting active tab", error);
    }
  };
useEffect(()=>{
  setActiveTab();
},[AffiliateID]);

  // const selectOptions=[{value:"Option 01"},{value:"Option 03"},{value:"Option 04"},]
  const selectOptions = AffiliateData.filter(({ AffiliateID }) => UserAffiliateList.includes(Number(AffiliateID))).map(({ AffiliateID, AffiliateCompany }) => ({
    value: AffiliateID,
    label: AffiliateCompany
  }));
  const handleChangeSelect = (value) => {
    console.log(value);
    setAffiliateID(value)
  }
  return (
    // <div className="p-4" style={{ display: 'flex'}}>
    <div className="p-4" style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
      <select class="form-select w-25" onChange={(e) => handleChangeSelect(e.target.value)} 
        value={AffiliateID}>
        <option value={""}>Select Affiliate</option>
        {selectOptions.map((opt, index) => <option key={index} value={opt.value}>{opt.label}</option>)}
      </select>
      <div style={{ display: 'flex' }}>
        <button
          onClick={() => setOuterActiveTab('ParaTransit')}
          style={{
            ...tabButtonStyle,
            ...(outerActiveTab === 'ParaTransit' ? activeTabStyle : {}),
            ...(outerActiveTab !== 'ParaTransit' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Paratransit
        </button>
        <button
          onClick={() => setOuterActiveTab('Cluster')}
          style={{
            ...tabButtonStyle,
            ...(outerActiveTab === 'Cluster' ? activeTabStyle : {}),
            ...(outerActiveTab !== 'Cluster' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Cluster
        </button>
        <button
          onClick={() => setOuterActiveTab('MicroTransit')}
          style={{
            ...tabButtonStyle,
            ...(outerActiveTab === 'MicroTransit' ? activeTabStyle : {}),
            ...(outerActiveTab !== 'MicroTransit' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Microtransit
        </button>
                <button
          onClick={() => setOuterActiveTab('Global Settings')}
          style={{
            ...tabButtonStyle,
            ...(outerActiveTab === 'Global Settings' ? activeTabStyle : {}),
            ...(outerActiveTab !== 'Global Settings' ? hoverTabStyle : {}),
            marginRight: '8px',
          }}
        >
          Global Settings
        </button>
      </div>

      {/* {outerActiveTab} */}
      {/* {outerActiveTab === "ParaTransit" ? <ParaTransit AffID={AffiliateID} SelectedDate={ new URLSearchParams(window.location.search).get('selectedDate')}/> : outerActiveTab === "Cluster" ? <Cluster AffID={AffiliateID} /> : <MicroTransit AffID={AffiliateID} />} */}
      {(outerActiveTab === "ParaTransit" || outerActiveTab === "Cluster" || outerActiveTab === "MicroTransit") ? 
  <ParaTransit  key={outerActiveTab}
   AffID={AffiliateID} 
  //  AffID={new URLSearchParams(window.location.search).get('id')} 
  // SettingType={(outerActiveTab === "Cluster" || outerActiveTab==="MicroTransit")? 4 : 0} 
  SettingType={
    outerActiveTab === "Cluster" ? 4 :
    outerActiveTab === "MicroTransit" ? 6 :
    0
  }
  _algorithms={_algorithms}
  /> : null}
{(outerActiveTab==="Global Settings")?
<GlobalSettings AffID={AffiliateID}  _algorithms={_algorithms}></GlobalSettings>:null
}
{/* {outerActiveTab === "ParaTransit" ? 
  <ParaTransit 
    key={outerActiveTab} 
    AffID={AffiliateID} 
    SelectedDate={new URLSearchParams(window.location.search).get('selectedDate')} 
    SettingType={0} 
  /> 
: null}

{outerActiveTab === "Cluster" ? 
  <Cluster 
    key={outerActiveTab} 
    AffID={AffiliateID} 
    SelectedDate={new URLSearchParams(window.location.search).get('selectedDate')} 
    SettingType={4} 
  /> 
: null}

{outerActiveTab === "MicroTransit" ? 
  <MicroTransit
    key={outerActiveTab} 
    AffID={AffiliateID} 
    SelectedDate={new URLSearchParams(window.location.search).get('selectedDate')} 
    SettingType={4} 
  /> 
: null} */}
    </div>

  );
};

export default TripFilterInterface;